import * as React from 'react';
import { IonContent, IonPage, IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { ErrorBoundary, useAppState } from 'oasis-os-react';
import { errorMessageRenderer } from '../../../Viewport/errors';
import Routes from '../../../Routes';
import SideNav from '../../../Sidenav';
import Header from '../../../Header';
import BottomNav from '../../../Bottomnav';
import RootFeatures from '../../../RootFeatures';
import './style.css';

const RouterOutlet: React.FC = () => {
  const [, , app] = useAppState();
  const [fixedRouterPosition, setFixedRouterPosition] = React.useState<boolean>(false);

  React.useEffect(() => {
    app.registerAction('setFixedRouterPosition', (hide: boolean) => {
      setFixedRouterPosition(hide);
    });
  });

  return (
    <IonRouterOutlet
      data-testid="router-outlet"
      className={`pwa__standard-template__router-outlet${
        fixedRouterPosition ? '__fixed-router-position' : ''
      }`}
    >
      <Routes />
    </IonRouterOutlet>
  );
};

const StandardLayouts: React.FC = () => {
  const [hideLayout, setHideLayout] = React.useState<boolean>(false);
  const [, , app] = useAppState();

  React.useEffect(() => {
    app.registerAction('hideLayout', (hide: boolean) => {
      setHideLayout(hide);
    });
  });

  return (
    <IonReactRouter basename={process.env.PUBLIC_PATH || '/'}>
      <RootFeatures />
      {hideLayout ? (
        <IonPage id="main">
          <IonContent>
            <ErrorBoundary errorMessage={errorMessageRenderer}>
              <IonRouterOutlet
                data-testid="router-outlet-on-hideLayout"
                className="pwa__standard-template__router-outlet__fixed-router-position"
              >
                <Routes />
              </IonRouterOutlet>
            </ErrorBoundary>
          </IonContent>
        </IonPage>
      ) : (
        <IonSplitPane contentId="main" when="md">
          <SideNav />
          <IonPage id="main">
            <Header />
            <IonContent>
              <ErrorBoundary errorMessage={errorMessageRenderer}>
                <RouterOutlet />
              </ErrorBoundary>
              <BottomNav />
            </IonContent>
          </IonPage>
        </IonSplitPane>
      )}
    </IonReactRouter>
  );
};
export default StandardLayouts;
